export default __webpack_public_path__ + "static/media/mastercard.inline.ebf74e51.svg";